
import { Injectable, EventEmitter } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SearchItem } from '../models/searchitem';

@Injectable()
export class SearchDataService {


    list:SearchItem[]=[];
    searchOption:SearchItem[]=[];

    constructor(private http: HttpClient) {

        this.populateSearchList();

    }

    private getJSON(): Observable<any> {
        return this.http.get("./assets/Data/searchmap.json")
    }

    private populateSearchList(){
        this.getJSON().subscribe(data=>{
            // console.log("search json map:", data);
            this.list = [data.length];
            for (var i = 0; i<data.length; i++){
                this.list[i]=new SearchItem();
                // console.log(data[i]);
                this.list[i].title = data[i].title;
                this.list[i].keywords = data[i].keywords;
                this.list[i].path = data[i].path;
                this.list[i].product = data[i].product;
            }
        });
    }

    public getSearchList():Observable<SearchItem[]>{

        let observable = Observable.create(observer => {
            setTimeout(() => {
                this.populateSearchList();

                observer.next(this.list); // This method same as resolve() method from Angular 1
                observer.complete();//to show we are done with our processing
                // observer.error(new Error("error message"));
            }, 2000);

            });

        return observable;

    }
}
